import Toggle from '@/components/Toggle';

const PageToggle = ({ label, value, disabled, onChange, size = 'md', hideLabel = false }) => {
  return (
    <div className={'comp-page-toggle-row'}>
      <Toggle size={size} active={value} onChange={onChange} disabled={disabled} />
      {!hideLabel && (label || (value ? 'Enabled' : 'Disabled'))}
    </div>
  );
};

export default PageToggle;
